import { Link } from "react-router-dom";
import { AppData } from "@/src/constants/app-data";
import { FooterBrand } from "./FooterBrand";

const SHOP_LINKS = [
    { label: "All Candles", to: "/collection" },
    { label: "Gift Sets", to: "/gift-sets" },
    { label: "Accessories", to: "/accessories" },
    { label: "Subscription", to: "/subscription" },
];
const SUPPORT_LINKS = [
    { label: "Shipping & Returns", to: "/shipping-returns" },
    { label: "Candle Care", to: "/candle-care" },
    { label: "FAQ", to: "/faq" },
    { label: "Contact Us", to: "/contact" },
];

function FooterColumn({
    title,
    items,
}: {
    title: string;
    items: { label: string; to: string }[];
}) {
    return (
        <div>
            <h4 className="text-white font-medium mb-6 uppercase tracking-widest text-xs">
                {title}
            </h4>
            <ul className="space-y-4 text-sm font-light">
                {items.map(({ label, to }) => (
                    <li key={label}>
                        <Link
                            to={to}
                            className="hover:text-white transition-colors"
                        >
                            {label}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export function Footer() {
    return (
        <footer className="bg-stone-900 text-stone-400 py-16 px-6">
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
                <FooterBrand />
                <FooterColumn title="Shop" items={SHOP_LINKS} />
                <FooterColumn title="Support" items={SUPPORT_LINKS} />
                <div>
                    <h4 className="text-white font-medium mb-6 uppercase tracking-widest text-xs">
                        Visit
                    </h4>
                    <p className="text-sm font-light leading-relaxed">
                        42 Artisans Row
                        <br />
                        Shoreditch, London
                        <br />
                        EC2A 3NS
                    </p>
                    <p className="text-sm font-light mt-4">
                        Mon — Sat: 10am - 7pm
                        <br />
                        Sun: 11am - 5pm
                    </p>
                </div>
            </div>
            <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] uppercase tracking-[0.2em]">
                <p>© 2026 {AppData["AppName"]}. All rights reserved.</p>
                <div className="flex gap-8">
                    <Link to="/privacy-policy" className="hover:text-white transition-colors">
                        Privacy Policy
                    </Link>
                    <Link to="/terms-of-service" className="hover:text-white transition-colors">
                        Terms of Service
                    </Link>
                </div>
            </div>
        </footer>
    );
}
